import { Button } from "@/components/ui/button";
import { useStaleAppVersion } from "@/lib/hooks/useStaleAppVersion";
import { isLikelyStaleClientError } from "@/lib/staleClientError";

type AppErrorFallbackProps = {
  actionLabel?: string;
  description: string;
  enableVersionCheck?: boolean;
  error?: unknown;
  onAction: () => void;
  title: string;
};

export default function AppErrorFallback({
  actionLabel = "Retry",
  description,
  enableVersionCheck = false,
  error,
  onAction,
  title,
}: AppErrorFallbackProps) {
  const staleClientError = isLikelyStaleClientError(error);
  const { updateAvailable } = useStaleAppVersion(
    enableVersionCheck && !staleClientError,
  );
  const shouldShowUpdateCopy = staleClientError || updateAvailable;
  const resolvedTitle = shouldShowUpdateCopy
    ? "A new version of this screen is available."
    : title;
  const resolvedDescription = shouldShowUpdateCopy
    ? "This page was updated while you were using the app. Refresh to load the latest version before continuing."
    : description;
  const resolvedActionLabel = shouldShowUpdateCopy
    ? "Refresh now"
    : actionLabel;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
      <h1 className="mb-2 text-2xl font-bold">{resolvedTitle}</h1>
      <p className="mb-4 max-w-md text-sm text-muted-foreground">
        {resolvedDescription}
      </p>
      <Button onClick={onAction}>{resolvedActionLabel}</Button>
    </div>
  );
}
